import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {AlgoliaManager} from '../../data/manager/algolia/algolia.manager';
import {DepartmentManager} from '../../data/manager/department/department.manager';
import {ConfigurationManager} from '../../data/manager/configuration/configuration.manager';
import { PrimeManager } from 'src/app/data/manager/prime/prime.manager';
import { CartManager } from 'src/app/data/manager/cart/cart.manager';
@Injectable({
  providedIn: 'root',
})
export class DepartmentsVm {
  public customer: any;
  constructor(public algoliaManager: AlgoliaManager,
              private departments: DepartmentManager,
              private configurationManager: ConfigurationManager,
              private primeManager: PrimeManager,
              private cartManager : CartManager
              ) {}

  getDepartments(): Observable<any> {
    return this.departments.get();
  }

  getConfigurationModules(): any {
    return this.configurationManager.getConfigurationModule('general');
  }

  getSetColorsHeaderAlgolia( ids ): Promise<any>{
    return this.algoliaManager.getObjectsIdsByProperties( ids );
  }

  getPrimeSubscription(customer):Observable<any>{
    if(customer && customer?.id !== 0){
      return this.primeManager.getPrimeSubscription(customer.id);
    }else{
      return of({ active: false })
    }
  }

  getPrimeConfig() {
    return this.algoliaManager.primeBrowse();
  }

  async setPrimeConfig(){
    return await this.getPrimeConfig().then( res=>{
      return res[0];
    });
  }

  sendEventTalonOne(data):Observable<any>{
    return this.cartManager.sendEventTalonOne(data)
  }

}
